'use strict';

module.exports.GUI = require('./visualizer/annotations');
module.exports.Ranges = require('./range/Ranges');



//////////////////
// WEBPACK FOOTER
// ./~/spectra-data-ranges/src/index.js
// module id = 19
// module chunks = 0